import React from "react"
import { useTranslation } from "react-i18next"
import { LeftOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import AddStaffForm from "./AddStaffForm"
import styles from "./AddStaffModal.module.css"

const AddStaffFullScreen = ({ open, onCancel, onSave, userId, staffId, editMode = false }) => {
  const { t } = useTranslation()
  const screens = useBreakpoint()
  const isMobileOrTablet = !screens.lg

  if (!open) return null

  return (
    <div className={styles.fullScreenContainer}>
      <div className={styles.fullScreenHeader}>
        {isMobileOrTablet && (
          <button className={styles.fullScreenBackButton} onClick={onCancel} aria-label={t("common.back")}>
            <LeftOutlined style={{ fontSize: 20 }} />
          </button>
        )}
        <Text className={styles.fullScreenTitle}>{editMode ? t("staff.edit_staff_modal.title") : t("staff.add_staff_modal.title")}</Text>
      </div>
      <AddStaffForm
        key={staffId || "new"}
        open={open}
        onCancel={onCancel}
        onSave={onSave}
        userId={userId}
        staffId={staffId}
        editMode={editMode}
        isFullScreen={true}
      />
    </div>
  )
}

export default AddStaffFullScreen
